import script from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SupervisionBanner.vue?vue&type=style&index=0&id=c19730b6&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c19730b6"]])

export default __exports__